import { useEffect, useState } from 'react';
import { attemptConnection } from '@/lib/attempt-connection';

/** Shared with every attempt banner. A failed fetch started before reconnect cannot flip it. */
export function useOnlineStatus() {
  const [online, setOnline] = useState(attemptConnection.online);

  useEffect(() => attemptConnection.subscribe(() => setOnline(attemptConnection.online)), []);

  return { online };
}
